import { DaySequence } from '../generated/gql-types';

// TODO: Replace with the generated types once codegen runs against a backend
// that has getTimesheetsForApproval.
export enum TimesheetApprovalView {
  /** Submitted, and waiting for the client or agency to approve. */
  Pending = 'PENDING',
  Approved = 'APPROVED',
}

export interface TimesheetApprovalItem {
  daySequence: DaySequence;
  workerName?: string | null;
  workerProfileImageUrl?: string | null;
  jobTitle?: string | null;
  jobTimezone?: string | null;
  workType?: string | null;
  siteId?: string | null;
  siteName?: string | null;
  clientId: string;
  clientName?: string | null;
}

export interface TimesheetApprovalPage {
  items: TimesheetApprovalItem[];
  hasMore: boolean;
  lastEvaluatedKey?: string | null;
}
